export default {
  CHAT: {
    TITLE: 'Chats',
    SEARCH: 'Buscar candidat@ u oferta',
    ALL: 'Todos',
    UNREAD: 'No leídos',
    OFFERS: 'Filtrar por oferta',
    YOU: 'Tú',
    OFFERS_FILTER: {
      SELECT_OFFERS: 'Selecciona ofertas',
      SEARCH: 'Buscar oferta',
      CANCEL: 'Cancelar',
      APPLY_FILTER: 'Aplicar filtro',
    },
    QUICK_CHAT: {
      TITLE: 'Chat con {{name}}',
      TITLE_FALLBACK: 'Chat',
      SEND: 'Enviar',
      OPEN_FULL_CHAT: 'Abrir chat completo',
      ATTACHMENT: 'Archivo adjunto',
      SEND_ERROR: 'No se pudo enviar el mensaje. Inténtalo de nuevo.',
    },
    WRITE_MESSAGE: 'Escribe un mensaje...',
    DIVIDER: { NEW: 'Nuevos' },
    NO_RESULTS: {
      TITLE: 'No se han encontrado resultados',
      SUBTITLE: 'Intenta con otra búsqueda.',
    },
    NO_CHATS_LIST: {
      TITLE: 'Todavía no tienes ningún chat',
      SUBTITLE: 'Aquí aparecerán tus conversaciones con<br>candidat@s una vez que l@s contactes.',
    },
    NO_CHATS: 'Selecciona un chat para comenzar.',
    NO_CHATS_HINT: 'Si aún no tienes ningún chat es porque en wokap tú das el primer paso: l@s candidat@s no pueden enviarte mensajes hasta que tú l@s contactes primero.',
    NO_MESSAGES: {
      TITLE: 'El chat está vacío',
      SUBTITLE: 'Envía un mensaje para iniciar la conversación.',
    },
    MESSAGE_ATTACHMENT_ERROR: {
      TITLE: 'Archivo no permitido',
      SUBTITLE: 'Por favor, selecciona una imagen (jpg, png, gif) o un documento (pdf, doc, docx).',
    },
    MESSAGE_DELETED: 'Se eliminó este mensaje',
    MESSAGE_EDITED: 'Editado',
    EDIT_MESSAGE: {
      TOOLTIP: 'Editar mensaje',
      TITLE: 'Editar mensaje',
      PLACEHOLDER: 'Escribe el nuevo contenido...',
      MEDIA_NOTE: 'Solo se puede modificar el texto. Los archivos adjuntos no son editables.',
      CANCEL: 'Cancelar',
      SAVE: 'Guardar',
      SUCCESS_SUMMARY: 'Mensaje editado',
      SUCCESS_DETAIL: 'El mensaje se ha editado correctamente.',
    },
    DELETE_MESSAGE: {
      TOOLTIP: 'Eliminar mensaje',
      CONFIRM_TITLE: 'Eliminar mensaje',
      CONFIRM_BODY: '¿Estás segur@ que quieres eliminar este mensaje? Esta acción no se puede deshacer.',
      CONFIRM_YES: 'Eliminar',
      CONFIRM_NO: 'Cancelar',
      SUCCESS_SUMMARY: 'Mensaje eliminado',
      SUCCESS_DETAIL: 'El mensaje se ha eliminado correctamente.',
    },
    DELETE_CHAT: {
      TOOLTIP: 'Eliminar conversación',
      CONFIRM_TITLE: 'Eliminar conversación',
      CONFIRM_BODY: '¿Estás segur@ que quieres eliminar esta conversación? Se borrarán todos los mensajes y esta acción no se podrá deshacer.',
      CONFIRM_YES: 'Eliminar',
      CONFIRM_NO: 'Cancelar',
      SUCCESS_SUMMARY: 'Conversación eliminada',
      SUCCESS_DETAIL: 'La conversación se ha eliminado correctamente.',
    },
    ERRORS: {
      MESSAGE_NOT_FOUND: 'El mensaje no existe.',
      MESSAGE_NOT_AUTHORIZED: 'No tienes permiso para realizar esta acción.',
      MESSAGE_ALREADY_DELETED: 'El mensaje ya ha sido eliminado.',
      MESSAGE_EDIT_WINDOW_EXPIRED: 'El tiempo para editar este mensaje ha expirado (30 minutos).',
      UNKNOWN_ERROR: 'Ha ocurrido un error inesperado.',
    },
  },
} as const;
